//@ts-nocheck
import Vue from "vue";
import store from "../store";

Vue.filter("formatCurrency", formatCurrency);
Vue.filter("formatQuantity", formatQuantity);
Vue.filter("formatNumber", (value) => {
  const local = store.state.app.local;
  if (!value) {
    return "-";
  }
  const temp = value.toLocaleString(local.code);
  const decimalSeparatorIndex = temp.indexOf(local.decimal_separator);
  const length = temp.length;
  let formattedValue = temp;
  if (decimalSeparatorIndex != -1) {
    const usedIndex = decimalSeparatorIndex + 3;
    if (length > usedIndex) {
      formattedValue = temp.substring(0, usedIndex);
    }
  }
  return formattedValue;
});

Vue.filter("formatNumber3Digit", (value) => {
  const local = store.state.app.local;
  if (!value) {
    return "-";
  }
  const temp = value.toLocaleString(local.code);
  const decimalSeparatorIndex = temp.indexOf(local.decimal_separator);
  const length = temp.length;
  let formattedValue = temp;
  if (decimalSeparatorIndex != -1) {
    const usedIndex = decimalSeparatorIndex + 4;
    if (length > usedIndex) {
      formattedValue = temp.substring(0, usedIndex);
    }
  }
  return formattedValue;
});
Vue.filter("formatZeroNumber", (value) => {

  const local = store.state.app.local;
  if (!value) {
    return "0";
  }
  const temp = value.toLocaleString(local.code);
  const decimalSeparatorIndex = temp.indexOf(local.decimal_separator);
  const length = temp.length;
  let formattedValue = temp;
  if (decimalSeparatorIndex != -1) {
    const usedIndex = decimalSeparatorIndex + 3;
    if (length > usedIndex) {
      formattedValue = temp.substring(0, usedIndex);
    }
  }
  return formattedValue;
});

Vue.filter("formatZeroCurrency", formatZeroCurrency);
Vue.filter("formatDynamicDecimalPlace", (value) => {
  const currency = store.state.app.currency;
  let decimalPlaces = 2;
  if (Math.floor(Number(value)) === Number(value)) decimalPlaces = 2;
  else decimalPlaces = String(value).split(".")[1].length || 2;
  return numberFormat(
    value,
    (decimalPlaces < 2) ? 2 : decimalPlaces,
    currency.decimalSeparator,
    currency.thousandsSeparator
  );
});

export function dynamicDecimalPlacesMax3(value: any): number {
  const rounded = Number(Number(value).toFixed(3));
  if (!Number.isFinite(rounded) || Math.floor(rounded) === rounded) {
    return 2;
  }
  const decimals = rounded.toString().split(".")[1]?.length ?? 0;
  return decimals > 2 ? 3 : 2;
}

Vue.filter("formatDynamicDecimalPlaceMax3", (value: any) => {
  const currency = store.state.app.currency;
  return numberFormat(
    value,
    dynamicDecimalPlacesMax3(value),
    currency.decimalSeparator,
    currency.thousandsSeparator
  );
});

/**
 * Returns the currency formatted accordingly
 */
export function formatCurrency(value, currency) {
  currency = currency || store.state.app.currency;
  return formatPrice(value, currency);
}

/**
* Returns the price passed formatted according to the system configurations for the currency
*
* @param price
* @returns {*}
*/
export function formatPrice(price, currency) {
  try {
    const numberFormatted = numberFormat(
      price,
      currency.decimalDigits,
      currency.decimalSeparator,
      currency.thousandsSeparator
    );

    if (currency.currencySymbol) {
      const priceSeparator = currency.currencySymbolNumberOfSpaces > 0
        ? " ".repeat(currency.currencySymbolNumberOfSpaces)
        : "";
      let priceParts = [numberFormatted, priceSeparator, currency.currencySymbol];

      if (currency.currencySymbolPosition === "left") {
        priceParts = priceParts.reverse();
      }

      return priceParts.join("");
    } else {
      return numberFormatted;
    }
  } catch (e) {
    return price;
  }
}

/**
   * Helper method to format a number given a few configurations such as the separation
   * between thousands and decimals
   *
   * @param number
   * @param decimals
   * @param dec_point
   * @param thousands_sep
   * @returns {*}
   */
export function numberFormat(number, decimals, dec_point, thousands_sep) {
  if (isNaN(number)) {
    return number;
  }
  const negative = number < 0;
  if (negative) number = number * -1;
  const str = Number(number).toFixed(decimals ? decimals : 0).toString().split(".");
  const parts = [];

  for (let i = str[0].length; i > 0; i -= 3) {
    parts.unshift(str[0].substring(Math.max(0, i - 3), i));
  }

  str[0] = parts.join(thousands_sep ? thousands_sep : ",");

  return (negative ? "-" : "") + str.join(dec_point ? dec_point : ".");
}

export function formatZeroCurrency(value){
  const currency = store.state.app.currency;
  return numberFormat(
    value,
    currency.decimalDigits,
    currency.decimalSeparator,
    currency.thousandsSeparator
  );
}

export function formatQuantity(value){
  const currency = store.state.app.currency;
  let decimalPlaces = 0;
  if (Math.floor(Number(value)) === Number(value)) decimalPlaces = 0;
  else decimalPlaces = String(value).split(".")[1].length || 0;
  return numberFormat(
    value,
    (decimalPlaces > 3) ? 3 : decimalPlaces,
    currency.decimalSeparator,
    currency.thousandsSeparator
  );
}
export default {
  formatPrice,
  numberFormat
};
